import type { ReactNode } from 'react';
import { css } from 'styled-system/css';

export function FormulaAddrBar({
  addr,
  value,
}: {
  addr: string;
  value?: ReactNode;
}) {
  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'stretch',
        height: '32px',
        flexShrink: 0,
        borderBottom: '1px solid token(colors.border.hairline)',
      })}
    >
      <span
        className={css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          flexShrink: 0,
          fontFamily: 'mono',
          fontSize: '2xs',
          fontWeight: 'semibold',
          color: 'text.muted',
          borderRight: '1px solid token(colors.border.hairline)',
        })}
      >
        {addr}
      </span>
      <span
        className={css({
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          minWidth: 0,
          paddingInline: '2.5',
          fontFamily: 'mono',
          fontSize: '2xs',
          color: 'text.primary',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        })}
      >
        {value}
      </span>
    </div>
  );
}
